import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { User } from "@/types";
import { api, UnprocessableEntityError } from "@/utils/api";
import { camelize, underscore } from "@/utils/api-helpers";

export type CreateUserInput = {
  externalId: string;
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  avatar?: string;
  locale?: string;
  timezone?: string;
  customFields?: Record<string, unknown>;
};

export const useCreateUser = (
  projectId: string,
  options: Omit<UseMutationOptions<User, UnprocessableEntityError, CreateUserInput, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<User, UnprocessableEntityError, CreateUserInput, unknown>({
    mutationFn: async (input: CreateUserInput): Promise<User> => {
      const response = await api.post<User>(`/projects/${projectId}/users`, underscore(input));
      return camelize(response.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "users"],
      });
    },
    ...options
  });
};
